<template>
	<div class="PopTip">
		<el-dialog :visible.sync="dialogVisible" :lock-scroll="false">
			<div class="wenxintishi">
				<div class="pop-header">
					<div class="ph-title">温馨提示</div>
					<div class="ph-close pointer" @click="close"></div>
				</div>
				<slot v-bind:popData="popData">
					<div class="pop-body">
						<div class="pb-icon" :class="popData.type"></div>
						<div class="pb-content">{{popData.content}}</div>
					</div>
				</slot>
				<div class="pop-footer">
					<div class="pf-cancel btn-fill" @click="close">取消</div>
					<div class="pf-confirm btn-fill" @click="confirm">{{popData.confirmText}}</div>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	var that = {}
	var popData = {
		content: '',
		type: 'warning',
		confirmText: '确定'
	}
	export default {
		name: 'PopTip',//添加子账号
		props: {
			show: {
				type: Boolean,
				default: false
			},
		},
		data() {
			return {
				dialogVisible: false,
				popData: {
					...popData
				},
			}
		},
		watch: {
			show: {
				handler: function(val) {
					this.dialogVisible = val
				},
				immediate: true
			},
			dialogVisible: {
				handler: function(val) {
					this.$emit('update:show', val)
				}
			},
			
		},
		created() {
			that = this
		},
		methods: {
			open(data={}) {
				this.popData = {...popData,...data}
				this.dialogVisible = true
			},
			close() {
				if (this.popData.cancel){
					this.popData.cancel()
				}
				this.dialogVisible = false
			},
			confirm() {
				if (this.popData.confirm){
					this.popData.confirm()
				}
				this.dialogVisible = false
			},
			
		}
	}
</script>

<style lang="scss" scoped>
	.PopTip {
		.wenxintishi {
			width: 600px;
			min-height: 272px;
			background: #FFFFFF;
			border-radius: 8px 8px 8px 8px;
			box-sizing: border-box;
			padding: 0 20px;
			display: flex;
			flex-direction: column;
		
			.pop-header {
				height: 56px;
				display: flex;
				align-items: center;
				position: relative;
				border-bottom: 1px solid #EDEDED;
		
				.ph-title {
					font-size: 16px;
					font-family: Microsoft YaHei, Microsoft YaHei;
					font-weight: 400;
					color: #333333;
					line-height: 16px;
				}
		
				.ph-close {
					width: 16px;
					height: 16px;
					background-image: url('../assets/058.png');
					background-size: 100% 100%;
					position: absolute;
					right: 0;
				}
			}
		
			.pop-body {
				flex: 1;
				box-sizing: border-box;
				padding: 50px 40px;
				display: flex;
				align-items: center;
		
				.pb-icon {
					width: 20px;
					height: 20px;
					background-size: 100% 100%;
					margin-right: 10px;
					
					&.warning {
						background-image: url('../assets/066.png');
					}
					&.success {
						background-image: url('../assets/072.png');
					}
				}
		
				.pb-content {
					flex: 1;
					font-size: 14px;
					font-family: Microsoft YaHei, Microsoft YaHei;
					font-weight: 400;
					color: #666666;
				}
			}
		
			.pop-footer {
				border-top: 1px solid #EDEDED;
				height: 72px;
				display: flex;
				justify-content: center;
				align-items: center;
		
				.pf-cancel {
					width: 88px;
					height: 32px;
					border-radius: 4px 4px 4px 4px;
					opacity: 1;
					border: 1px solid #3571DA;
					display: flex;
					justify-content: center;
					align-items: center;
					font-size: 14px;
					font-family: Microsoft YaHei, Microsoft YaHei;
					font-weight: 400;
					color: #3571DA;
					line-height: 14px;
					box-sizing: border-box;
					margin: 0 10px;
				}
		
				.pf-confirm {
					width: 88px;
					height: 32px;
					background: #3571DA;
					border-radius: 4px 4px 4px 4px;
					font-size: 14px;
					font-family: Microsoft YaHei, Microsoft YaHei;
					font-weight: 400;
					color: #FFFFFF;
					line-height: 32px;
					text-align: center;
					margin: 0 10px;
				}
			}
		}
	}
</style>